<template>
    <div class="m-3">
        <failed-edi-file-upload-filters></failed-edi-file-upload-filters>
        <div class="d-flex justify-content-between border-bottom">
            <h2>Failed EDI File Uploads</h2>
            <div class="btn-toolbar mb-2" role="toolbar">
                <div class="input-group mr-2">
                    <div class="input-group-prepend">
                        <div class="input-group-text"><i class="fas fa-search fa-lg text-muted"></i></div>
                    </div>
                    <input type="text" class="form-control" size="50" placeholder="Search Filenames" v-model="searchString" @keyup.enter="search()">
                    <div class="input-group-append">
                        <button class="btn btn-primary" @click="search()"><i class="fas fa-search fa-lg"></i></button>
                    </div>                    
                </div>
                <div class="btn-group">
                    <button class="btn btn-primary" data-toggle="tooltip" title="Filters" @click="showFilters()">
                        <i class="fas fa-filter fa-lg"></i>                   
                    </button>
                </div>                 
            </div>
        </div>
        <div v-if="loading" class="pt-3">            
            <h3 class="text-muted text-center"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</h3>
        </div>        
        <div v-else-if="files.length" class="table-responsive px-2">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th>Filename</th>
                        <th>Inbound Filename</th>             
                        <th>Failed At</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="file in files" :key="'failed-edi-file-upload-' + file.id">
                        <td><a :href="'/admin/files/837/failed/' + file.id" class="px-1" :title="file.original_filename">{{ file.original_filename | truncate(50) }}</a></td>
                        <td>{{ file.filename | truncate(50) }}</td>                 
                        <td>{{ file.failed_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                        <td><a :href="'/admin/files/837/failed/download/' + file.id" title="Download File"><i class="fas fa-lg fa-file-download"></i></a></td>
                    </tr>                    
                </tbody>
            </table>
            <div class="d-flex">
                <nav v-if="pageCount > 1" aria-label="Page navigation">
                    <ul class="pagination">
                        <li v-bind:class="['page-item', { 'disabled' : currentPage == 1 }]">
                            <a class="page-link" href="#" @click="first()">
                                <span id="first-page"><i class="fas fa-step-backward fa-xs chev-pos"></i></span>
                            </a>
                        </li>                         
                        <li v-bind:class="['page-item', { 'disabled' : currentPage == 1 }]">
                            <a class="page-link" href="#" @click="previous()">
                                <span id="previous"><i class="fas fa-chevron-left fa-xs chev-pos"></i><i class="fas fa-chevron-left fa-xs mr-1 chev-pos"></i>Previous</span>
                            </a>
                        </li>
                        <li v-bind:class="['page-item', { 'disabled' : currentPage == pageCount }]">
                            <a class="page-link" href="#" @click="next()">
                                <span id="next">Next<i class="fas fa-chevron-right fa-xs ml-2 chev-pos"></i><i class="fas fa-chevron-right fa-xs chev-pos"></i></span>
                            </a>
                        </li>
                        <li v-bind:class="['page-item', { 'disabled' : currentPage == pageCount }]">
                            <a class="page-link" href="#" @click="last()">
                                <span id="first-page"><i class="fas fa-step-forward fa-xs chev-pos"></i></span>
                            </a>
                        </li>                         
                    </ul>
                </nav>
                <div class="ml-auto"> Page {{ currentPage }} of {{ pageCount }}</div>
            </div>

        </div>
        <div v-else>
            <h4 class="text-muted text-center mt-2">No failed EDI file uploads.</h4>
        </div>        
    </div>    
</template>

<script>
import FailedEdiFileUploadFilters from './FailedEdiFileUploadFilters.vue';
export default {
    components: {
        FailedEdiFileUploadFilters
    },    
    data() {
        return {
            loading: false,
            files: [],
            searchString: '',
            filters: {
                beginDate: null,
                endDate: null                
            },
            currentPage: 1,
            pageCount: 0         
        }
    },    
    methods: {
        refresh: function () {

            this.loading = true;

            let filters = { ...this.filters }
            if (this.filters.beginDate && this.filters.endDate) {

                filters.beginDate = this.getBeginDateISOString(this.filters.beginDate);
                filters.endDate = this.getEndDateISOString(this.filters.endDate);
            }

            axios.get('/ajax/admin/reports/failed-edi-file-uploads', {
                    params: {
                        'page': this.currentPage - 1,
                        'searchString': this.searchString,
                        'filters': filters
                    }                  
                })
                .then(response => {

                    this.files = response.data.files;
                    this.pageCount = response.data.page_count;
                    this.loading = false;
                })
                .catch(error => {

                    console.log(error.response);
                    this.loading = false;
                });
        },        
        search: function () {

            this.currentPage = 1;
            this.refresh();
        },  
        showFilters: function () {

            eventHub.$emit('show-failed-edi-file-upload-filters', this.filters, this.filter);
        },
        filter: function (filters) {
            this.filters = filters;
            this.refresh();
        },        
        getBeginDateISOString: function (value) {

            // set the begin date to the beginning of the day UTC time
            let date = new Date(value);
            date.setUTCHours(0, 0, 0, 0);
            return date.toISOString();
        },
        getEndDateISOString: function (value) {

            // set the end date to the end of the day UTC time
            let date = new Date(value);
            date.setUTCHours(23, 59, 59, 999);
            return date.toISOString();
        },
        first: function () {
            if (this.currentPage > 1) {
                this.currentPage = 1;
                this.refresh();
            }
        },        
        previous: function() {
            if (this.currentPage > 0) {
                this.currentPage--;
                this.refresh();
            }
        },
        next: function() {
            if (this.currentPage < this.pageCount) {
                this.currentPage++;
                this.refresh();
            }
        },
        last: function () {
            if (this.currentPage < this.pageCount) {
                this.currentPage = this.pageCount;
                this.refresh();
            }
        }                
    },
    created() {

        this.refresh();
    }    
}
</script>

<style scoped>

</style>